import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function PersonIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 17 20"
        {...props}
      >
        <ellipse cx={8.5} cy={5.26} fill="none" rx={5.31} ry={5.26} />
        <path
          fill="none"
          d="M6.38 9.47h4.25c3.5-.02 6.35 2.81 6.37 6.31V20H0v-4.21a6.346 6.346 0 0 1 6.38-6.32"
        />
        <path d="M11.56 9.55a5.22 5.22 0 0 0 2.25-4.29c0-2.93-2.38-5.31-5.31-5.31S3.19 2.33 3.19 5.26c0 1.71.84 3.31 2.25 4.29C2.33 10 .02 12.65 0 15.79v2.63C.01 19.29.72 20 1.59 20h13.82c.87 0 1.58-.71 1.59-1.58v-2.63a6.344 6.344 0 0 0-5.44-6.24m-3.06-8c2.04.02 3.68 1.68 3.66 3.72s-1.68 3.68-3.72 3.66a3.69 3.69 0 0 1-3.66-3.67A3.704 3.704 0 0 1 8.5 1.58zm6.91 16.84H1.59v-2.6a4.774 4.774 0 0 1 4.79-4.74h4.24a4.774 4.774 0 0 1 4.79 4.74z" />
      </svg>
    </Icon>
  )
}
export default PersonIcon
